import React from "react";
import { Control } from "react-hook-form";
import TextFieldController from "src/components/TextFieldController";
import { Strings } from "src/resources";
import { rules } from "src/utils/validationPattern";

function LoginForm({ control }: LoginFormPropsType) {
  return (
    <>
      <TextFieldController
        name="email"
        control={control}
        rules={rules.email(Strings.email)}
        label={Strings.email}
        dataCy="loginEmail"
      />
      <TextFieldController
       name="password"
       control={control}
       rules={rules.global(Strings.password)}
        label={Strings.password}
        dataCy="loginPassword"
        type="password"
        eyeIcon
      />
    </>
  );
}

type LoginFormPropsType = {
  control: Control;
};

export default LoginForm;
